<vt-styled-authorization-page [content]="loginForm"></vt-styled-authorization-page>

<ng-template #loginForm>
  <vt-login-form
  (submitted)="onSubmit($event)"
  [pending]="pending$ | async"
  [errorMessage]="error$ | async"
  (downloadHelp)="onDownloadHelp()"
></vt-login-form>
</ng-template>